import React from "react";
import Avatar from "antd/lib/avatar";
import Tooltip from "antd/lib/tooltip";
import aiInsightsblue from "../../../../../assets/AIGeneratedInsights/AI_Insights_Blue.svg";
import aiInsightsgreen from "../../../../../assets/AIGeneratedInsights/AI_Insights_green.svg";
import betaBtn from "../../../../../assets/AIGeneratedInsights/beta_btn.svg";
import config from "../../../../../config";
import { useDispatch, useSelector } from "react-redux";

import isEqual from "react-fast-compare";
import { getPaneIndex } from "../../../../../redux/constants";
import { setWidgetAIGeneratedInsightsOpenStatus } from "../../../../../redux/actions/dashboard/Tab1";
import {
  setAIGeneratedInsights,
  setAIInsightStatus,
} from "../../../../../redux/actions/PPT";

const AIinsight = ({
  section_index,
  widget_index,
  allData,
  chart_type,
  metaWidgetGraphData,
  widgetData,
}) => {
  const dispatch = useDispatch();
  const authParams = useSelector((state) => state.Authentication.authParams);
  const panes = useSelector((state) => state.Tab1.panes);
  const activeKey = useSelector((state) => state.Tab1.activeKey);
  let index = getPaneIndex(panes, activeKey);
  const aiInsightsLoader = useSelector((state) => state.PPT.aiInsightsLoader);
  const isScheduleReportOpen = useSelector(
    (state) => state?.ApiCall?.is_schedule_report_open
  );

  const callInsights = (e) => {
    let sections = panes[index]?.sections
      ? panes[index]?.sections
      : panes[index]?.section;
    let payload =
      sections?.[section_index >= 0 ? section_index : 0]?.widgets?.[
        widget_index
      ]?.payload;

    let sectionName =
      section_index >= 0
        ? panes?.[index]?.sections?.[section_index]?.section_name
        : "";

    let widget = {
      pane_index: index,
      panes: panes,
      section_index: panes[index]?.sections ? section_index : null,
      widget_index: widget_index,
      widget_id:
        sections[section_index >= 0 ? section_index : 0]?.widgets[widget_index]
          ?.widget_id,
      dashboard_name: panes?.[index]?.template_name,
      section_name: sectionName,
    };
    let insights =
      sections &&
      sections[section_index >= 0 ? section_index : 0]?.widgets[widget_index]
        ?.insights;
    let open =
      sections &&
      sections[section_index >= 0 ? section_index : 0]?.widgets[widget_index]
        ?.open;
    if (open) {
      dispatch(
        setWidgetAIGeneratedInsightsOpenStatus(
          false,
          index,
          panes,
          widget?.section_index,
          widget?.widget_index
        )
      );
      if (e === "AIAdv") {
        dispatch(
          setAIInsightStatus({
            open: false,
            section_index: widget?.section_index,
            widget_index: widget?.widget_index,
          })
        );
      }
    } else {
      dispatch(
        setWidgetAIGeneratedInsightsOpenStatus(
          true,
          index,
          panes,
          widget?.section_index,
          widget?.widget_index
        )
      );
      if (e === "AIAdv") {
        dispatch(
          setAIInsightStatus({
            open: true,
            section_index: widget?.section_index,
            widget_index: widget?.widget_index,
          })
        );
      }
    }
    payload &&
      !insights &&
      dispatch(setAIGeneratedInsights(payload, widget, authParams));
  };

  const AiInsightsBrands =
    widgetData?.payload?.brand_list?.length === 1 &&
    !widgetData?.payload?.brand_groups &&
    !widgetData?.payload?.comp_brand_list;
  return (
    <>
      {AiInsightsBrands &&
      panes[index]?.template_id === "000-000-2001" &&
      panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
        ?.widget_name !== "Mentions Trend With Engagement" &&
      config?.config1?.app_id !== "6" ? (
        <Tooltip title="">
          <button
            onClick={() => callInsights("AIAdv")}
            className={`WidgetFilter_title border-0 aiInsights_ad text-center pt-2 pb-2 
                ${"ml-2"} ${aiInsightsLoader?.value && "state-disabled"}`}
            style={{
              borderColor: "#678bff33",
              lineHeight: "normal",
              minWidth: "17rem",
            }}
          >
            <Avatar
              style={{ marginRight: "0.5rem" }}
              shape="square"
              size={16}
              src={aiInsightsgreen}
              alt="AI Insights"
            />
            Insights Adv.{" "}
            <img
              style={{ marginLeft: "0.5rem", maxWidth: "3.5rem" }}
              //size={35}
              src={betaBtn}
              alt="AI Insights"
            />
          </button>
        </Tooltip>
      ) : (
        <button
          onClick={() => callInsights()}
          className={`WidgetFilter_title border-0 blue-text aiInsights text-center pt-1 pb-1 
                     ${"ml-2"} ${aiInsightsLoader?.value && "state-disabled"}`}
          style={{
            borderColor: "#678bff33",
            lineHeight: "normal",
            minWidth:
              widgetData?.span === "one_third"
                ? "3rem"
                : config?.config1?.app_id === "6"
                ? "9rem"
                : "12.8rem",
          }}
        >
          <Tooltip title={<span>AI Insights BETA</span>}>
            <Avatar
              style={{
                marginRight:
                  widgetData?.span === "one_third" ? "0rem" : "0.5rem",
              }}
              shape="square"
              size={16}
              src={aiInsightsblue}
              alt="AI Insights"
            />
            {widgetData?.span !== "one_third" && (
              <>
                Insights
                {config?.config1?.app_id === "6" ? (
                  ""
                ) : (
                  <img
                    style={{ marginLeft: "0.5rem", maxWidth: "3.5rem" }}
                    //size={35}
                    src={betaBtn}
                    alt="AI Insights"
                  />
                )}
              </>
            )}
          </Tooltip>
        </button>
      )}
    </>
  );
};

export default React.memo(AIinsight, isEqual);
